export class AgentInfo {
  constructor(json) {
    this.agentId = json.agentId;
    this.custom1 = json.custom1;
    this.custom2 = json.custom2;
    this.custom3 = json.custom3;
    this.custom4 = json.custom4;
    this.custom5 = json.custom5;
    this.email = json.email;
    this.firstName = json.firstName;
    this.internalId = json.internalId;
    this.isActive = json.isActive;
    this.isSupervisor = json.isSupervisor;
    this.lastLogin = json.lastLogin;
    this.lastModified = json.lastModified;
    this.lastName = json.lastName;
    this.location = json.location;
    this.middleName = json.middleName;
    this.reportToFirstName = json.reportToFirstName;
    this.reportToId = json.reportToId;
    this.reportToLastName = json.reportToLastName;
    this.reportToMiddleName = json.reportToMiddleName;
    this.teamId = json.teamId;
    this.teamName = json.teamName;
    this.userName = json.userName;
  }
}
